/**
 * @flow
 * @relayHash 9d0de7e0c6daa2e0fe711f1c7aca857c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type OrderStatus = "CONFIRMED" | "DELIVERED" | "IN_PRODUCTION" | "READY_FOR_SHIPMENT" | "SHIPPED" | "WAITING_FOR_CONFIRMATION" | "WAITING_FOR_PRODUCTION";
export type ShipmentStatus = "DELIVERED" | "DRAFT" | "READY" | "SHIPPED";
export type PickShipmentItemsInput = {|
  shipmentId: string,
  picks: $ReadOnlyArray<PickItemInput>,
|};
export type PickItemInput = {|
  shipmentItemId: string,
  lotId?: ?string,
  quantity: number,
|};
export type PickShipmentItemsMutationVariables = {|
  input: PickShipmentItemsInput
|};
export type PickShipmentItemsMutationResponse = {|
  +pickShipmentItems: {|
    +shipmentEdge: {|
      +node: {|
        +id: string,
        +shipmentNumber: string,
        +status: ShipmentStatus,
        +actualShipDate: ?any,
        +order: {|
          +id: string,
          +orderNumber: string,
          +status: OrderStatus,
        |},
        +customer: {|
          +id: string,
          +name: string,
        |},
        +items: {|
          +edges: ?$ReadOnlyArray<?{|
            +node: {|
              +id: string,
              +quantity: number,
              +pickedQuantity: number,
              +fullyPicked: boolean,
              +item: {|
                +id: string,
                +name: string,
                +itemNumber: string,
              |},
              +picks: ?$ReadOnlyArray<?{|
                +id: string,
                +quantity: number,
                +pickedAt: ?any,
                +lot: ?{|
                  +id: string,
                  +lotNumber: string,
                |},
              |}>,
            |}
          |}>
        |},
        +updatedAt: any,
      |}
    |}
  |}
|};
export type PickShipmentItemsMutation = {|
  variables: PickShipmentItemsMutationVariables,
  response: PickShipmentItemsMutationResponse,
|};
*/


/*
mutation PickShipmentItemsMutation(
  $input: PickShipmentItemsInput!
) {
  pickShipmentItems(input: $input) {
    shipmentEdge {
      node {
        id
        shipmentNumber
        status
        actualShipDate
        order {
          id
          orderNumber
          status
        }
        customer {
          id
          name
        }
        items(first: 1000) {
          edges {
            node {
              id
              quantity
              pickedQuantity
              fullyPicked
              item {
                id
                name
                itemNumber
              }
              picks {
                id
                quantity
                pickedAt
                lot {
                  id
                  lotNumber
                }
              }
            }
          }
        }
        updatedAt
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "PickShipmentItemsInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
},
v5 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "pickShipmentItems",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PickShipmentItemsPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "shipmentEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "ShipmentEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Shipment",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "shipmentNumber",
                "args": null,
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "actualShipDate",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "order",
                "storageKey": null,
                "args": null,
                "concreteType": "Order",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "orderNumber",
                    "args": null,
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "customer",
                "storageKey": null,
                "args": null,
                "concreteType": "Customer",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v3/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "items",
                "storageKey": "items(first:1000)",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000
                  }
                ],
                "concreteType": "ShipmentItemConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ShipmentItemEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ShipmentItem",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v4/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "pickedQuantity",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "fullyPicked",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              (v3/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "itemNumber",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "picks",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ShipmentPick",
                            "plural": true,
                            "selections": [
                              (v1/*: any*/),
                              (v4/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "pickedAt",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "lot",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Lot",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "lotNumber",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "updatedAt",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PickShipmentItemsMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v5/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "PickShipmentItemsMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v5/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "PickShipmentItemsMutation",
    "id": null,
    "text": "mutation PickShipmentItemsMutation(\n  $input: PickShipmentItemsInput!\n) {\n  pickShipmentItems(input: $input) {\n    shipmentEdge {\n      node {\n        id\n        shipmentNumber\n        status\n        actualShipDate\n        order {\n          id\n          orderNumber\n          status\n        }\n        customer {\n          id\n          name\n        }\n        items(first: 1000) {\n          edges {\n            node {\n              id\n              quantity\n              pickedQuantity\n              fullyPicked\n              item {\n                id\n                name\n                itemNumber\n              }\n              picks {\n                id\n                quantity\n                pickedAt\n                lot {\n                  id\n                  lotNumber\n                }\n              }\n            }\n          }\n        }\n        updatedAt\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '888d600ab37489f57275bdcf056865c3';
module.exports = node;
